import { __extends } from "tslib";
import { GetContentModerationRequest, GetContentModerationResponse } from "../models/index";
import { deserializeAws_json1_1GetContentModerationCommand, serializeAws_json1_1GetContentModerationCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetContentModerationCommand = /** @class */ (function (_super) {
    __extends(GetContentModerationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetContentModerationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetContentModerationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetContentModerationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetContentModerationResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetContentModerationCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetContentModerationCommand(input, context);
    };
    GetContentModerationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetContentModerationCommand(output, context);
    };
    return GetContentModerationCommand;
}($Command));
export { GetContentModerationCommand };
//# sourceMappingURL=GetContentModerationCommand.js.map